import styled, { keyframes } from 'styled-components';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import Box from '@rsos/components/capstone/base/Box';

const expandContent = keyframes`
  0% {
    max-height: 0;
  }
  100% {
    max-height: 300px;
  }
`;

export const AccordionWrapper = styled(Box).attrs({
  p: 1,
  bg: 'background',
})`
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;

export const W3wContainer = styled(Box).attrs({
  marginBottom: '16px',
  transition: 'all 0.8s ease',
})`
  border-bottom: ${({ isShowing, renderStandalonePane }) =>
      isShowing && !renderStandalonePane ? '2px' : '0'}
    solid ${({ theme }) => theme.colors.heavyLineOutline};
  animation-name: ${({ isShowing }) => (isShowing ? expandContent : null)};
  animation-duration: 0.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
`;

export const CloseButton = styled(DCCloseButton)`
  margin-left: 2px;
`;
